<template>
  <div>
    <CCard>
      <CCardHeader>
        <h4>Gán nhân viên đơn vị</h4>
      </CCardHeader>
      <CCardBody>
        <CRow class="mb-12">
          <CCol sm="6">
            <CSelect
              :options="list_department_type"
              :value.sync="value_department_type"
            />
          </CCol>
          <CCol sm="6"></CCol>
        </CRow>
        <CRow class="mb-12">
          <CCol sm="6"> </CCol>
          <CCol sm="6"></CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import ClientFactory from "@/api/ClientFactory";
const dropdownsApi = ClientFactory.get("dropdowns");

export default {
  data: () => ({
    list_department_type: {},
    value_department_type: 0,
    employee_data: {},
  }),
  created() {
    this.GetDepartmentType();
    this.GetEmployee();
  },
  methods: {
    async GetDepartmentType() {
      let cat_code = "DEPARMENT_TYPE";
      this.list_department_type = await dropdownsApi.getItemsTree(cat_code);
    },
    async GetEmployee() {
      const { data } = await dropdownsApi.getEmployeeByDepartment();
      this.employee_data = data.data[0].departments;
      console.log(this.employee_data);
    },
  },
};
</script>
<style></style>
